// INDEX
export const SET_LEDGER_SELECT_DATE = 'SET_LEDGER_SELECT_DATE'
export const SET_PERIOD_SELECTION = 'SET_PERIOD_SELECTION'

// BUNDLES
export const SET_BUNDLES = 'SET_BUNDLES'

// COMPANIES
export const INIT_COMPANIES_REQUEST = 'INIT_COMPANIES_REQUEST'
export const INIT_COMPANIES_RETRY_REQUEST = 'INIT_COMPANIES_RETRY_REQUEST'
export const SET_PENDING_COMPANIES_REQUEST = 'SET_PENDING_COMPANIES_REQUEST'
export const APPEND_TO_COMPANIES = 'APPEND_TO_COMPANIES'
export const SET_CHUNK_DONE = 'SET_CHUNK_DONE'
export const SET_ERROR = 'SET_ERROR'
export const INCREASE_RETRIES_VALUE = 'INCREASE_RETRIES_VALUE'
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM'

// FILTERS
export const ADD_ACTIVE_FILTER = 'ADD_ACTIVE_FILTER'
export const UPDATE_ACTIVE_FILTER = 'UPDATE_ACTIVE_FILTER'
export const REMOVE_ACTIVE_FILTER = 'REMOVE_ACTIVE_FILTER'
export const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS'
export const UNSET_ACTIVE_FILTERS = 'UNSET_ACTIVE_FILTERS'
export const SET_EDIT_FILTER_MODAL = 'SET_EDIT_FILTER_MODAL'
export const SET_EDITING_FILTER = 'SET_EDITING_FILTER'
export const SET_FILTER_DROPDOWN_VALUES = 'SET_FILTER_DROPDOWN_VALUES'
export const SET_FILTER_DROPDOWN_VALUES_LOADING =
  'SET_FILTER_DROPDOWN_VALUES_LOADING'

// RECONCILIATION TEXTS
export const SET_RECONCILIATION_TEXTS = 'SET_RECONCILIATION_TEXTS'
export const SET_RECONCILIATION_TEXTS_IDENTIFIERS =
  'SET_RECONCILIATION_TEXTS_IDENTIFIERS'

// SEGMENTS
export const SET_SEGMENTS = 'SET_SEGMENTS'
export const SET_SEGMENT = 'SET_SEGMENT'
export const ADD_RECENT_SEGMENT = 'ADD_RECENT_SEGMENT'
export const SEGMENT_START_LOADING = 'SEGMENT_START_LOADING'
export const SEGMENT_STOP_LOADING = 'SEGMENT_STOP_LOADING'
export const UPDATE_SEGMENT = 'UPDATE_SEGMENT'
export const REMOVE_SEGMENT = 'REMOVE_SEGMENT'
export const SET_EDITED_SEGMENT = 'SET_EDITED_SEGMENT'
export const UNSET_EDITED_SEGMENT = 'UNSET_EDITED_SEGMENT'
export const SET_SEGMENT_MODAL_VISIBLE = 'SET_SEGMENT_MODAL_VISIBLE'
export const SET_SEGMENT_MODAL_TYPE = 'SET_SEGMENT_MODAL_TYPE'

// USERS
export const SET_USERS = 'SET_USERS'

// TRIGGERS
export const SET_EDITED_TRIGGER = 'SET_EDITED_TRIGGER'
export const UNSET_EDITED_TRIGGER = 'UNSET_EDITED_TRIGGER'
export const SET_TRIGGERS = 'SET_TRIGGERS'
export const SET_TRIGGER_RUNNING = 'SET_TRIGGER_RUNNING'
export const SET_TRIGGER_LOADING = 'SET_TRIGGER_LOADING'

// COLUMNS
export const TOGGLE_SORT_TYPE = 'TOGGLE_SORT_TYPE'
export const SET_SORT_COLUMN = 'SET_SORT_COLUMN'

export const TOGGLE_PREMIUM_INFO_MODAL = 'TOGGLE_PREMIUM_INFO_MODAL'

// SUBMISSIONS
export const SET_SUBMISSION_DATA = 'SET_SUBMISSION_DATA'

export const UPDATE_ACTIVE_FILTER_POSITION = 'UPDATE_ACTIVE_FILTER_POSITION'
export const RESET_ACTIVE_FILTER_POSITIONS = 'RESET_ACTIVE_FILTER_POSITIONS'
export const SET_PERIOD_SELECTION_OPEN = 'SET_PERIOD_SELECTION_OPEN'

export const COMPANIES_FULLY_LOADED = 'COMPANIES_FULLY_LOADED'
